module.exports = __webpack_public_path__ + "img/pic-logo-sgj.f54219e1.png";